export const AuthTokenSkipHeader = 'X-Skip-Auth-Token';
export const ErrToastSkipHeader = 'X-Skip-Error-Toast';
export const MAX_ALLOCATION = 8;
export const ONE_SEC = 1000;
export const SIXTY = 60;
export const HOURS_IN_DAY = 24;
export const ONE_MIN = ONE_SEC * SIXTY;
export const ONE_HOUR = ONE_MIN * SIXTY;
export const ONE_DAY = ONE_HOUR * HOURS_IN_DAY;
export const PERCENT = 100;
export enum DIGITS {
  ZERO,
  ONE,
  TWO,
  THREE,
  FOUR,
  FIVE,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
}
